import { render, staticRenderFns } from "./P2POffersExtra.vue?vue&type=template&id=4a97c5ce&scoped=true&"
import script from "./P2POffersExtra.vue?vue&type=script&lang=js&"
export * from "./P2POffersExtra.vue?vue&type=script&lang=js&"
import style0 from "./P2POffersExtra.vue?vue&type=style&index=0&id=4a97c5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97c5ce",
  null
  
)

export default component.exports